import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';

const PreviewImage = ({ image, category, src, loading }) => (
  <div className={`apply__${category}--image`}>
    {(() => {
      if (loading) {
        return (
          <div className={`apply__${category}--image-loading`}>
            <FontAwesomeIcon className={`apply__${category}--loading`} icon={faSpinner} spin />
          </div>
        );
      } else if (src) {
        return <img alt="preview" className={`apply__${category}--image-preview`} src={src} height="200" />;
      } else if (image) {
        return <img alt="preview" className={`apply__${category}--image-preview`} src={image} height="200" />;
      }
      return (
        <div
          className={`apply__${category}--image-empty`}
          onClick={() => {
            const input = document.getElementById('edit_photo');
            input.click();
          }}>
          <FontAwesomeIcon icon={faPlus} />Upload
        </div>
      );
    })()}
  </div>
);

export default PreviewImage;



// WEBPACK FOOTER //
// ./src/components/NycApply/PreviewImage.js